<div class="body">

    <div class="content" [innerHtml]="htmlBody"></div>

</div>
